export const navBarItems = [
  {
    label: "Home",
    route: "/",
  },
  {
    label: "About",
    route: "/about",
  },
  {
    label: "Experience",
    route: "/experience",
  },
  {
    label: "Projects",
    route: "/projects",
  },
];
